import axios from 'axios'
import OpenAI from 'openai'
import {CHAT_KEY} from '../Constants'

const openai = new OpenAI({
    apiKey: CHAT_KEY,
    dangerouslyAllowBrowser: true,
})

export async function sendMsgToOpenAI(message) {
    const res = await openai.chat.completions.create({
        messages: [{role: 'user', content: message}],
        model: 'gpt-3.5-turbo',
    })
    return res?.choices[0].message.content
}

//AI Detector

export const sendMsgToDetectorAI = message => {
    return axios
        .post(`https://api.sapling.ai/api/v1/aidetect`, {
            key: 'KGBNKFK65UOK7395HXSESKNC18M9T84H',
            text: message,
        })
        .then(res => {
            console.log('DetectorAI', res)
            return res.data
        })
        .catch(error => console.log('DetectorAI', error))
}

//AI Paraphrase

export const sendMsgToParaphraseAI = message => {
    return axios
        .post(
            `https://paraphrasing-and-rewriter-api.p.rapidapi.com/rewrite-light`,
            {from: 'en', text: message},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-RapidAPI-Key':
                        '2c584f0a1dmshdf94cc9edbcfca6p1cf0a8jsn45719c6280e4',
                    'X-RapidAPI-Host':
                        'paraphrasing-and-rewriter-api.p.rapidapi.com',
                },
            },
        )
        .then(res => {
            console.log('DetectorAI', res)
            return res.data
        })
        .catch(error => console.log('DetectorAI', error))
}
